import React, { useEffect, useState } from 'react'
import '../../styles/Solutions.css'
import { Link, useRouteMatch } from 'react-router-dom'
import MyselfIcon from '../../svg/MyselfIcon'
import FriendsIssuesIcon from '../../svg/FriendsIssuesIcon'
import FamilyIssuesIcon from '../../svg/FamilyIssuesIcon'
import SchoolIssueIcon from '../../svg/SchoolIssueIcon'
import { checkSolutionAccess } from '../../server/server'
import { useUser } from '../../context/user'
import i18n from '../../i18n'
import { useTranslation } from 'react-i18next'
export default function Solutions() {
    const { url } = useRouteMatch()
    const [loading, setLoading] = useState(true)
    const [solutionAccess, setSolutionAccess] = useState(false)
    const { user, setUser } = useUser()
    const { t } = useTranslation()
    useEffect(() => {
        checkSolutions()
    }, [])

    const checkSolutions = async () => {
        const data = {
            institution_id: user.institution_id,
        }
        const resp = await checkSolutionAccess(data)
        if (resp.status == 200) {
            setSolutionAccess(true)
        }
        setLoading(false)
    }
    return (
        <div className={`solutions-container blue-scroll ${i18n.language == 'ar' ? 'ar-trans' : ''}`}>
            {solutionAccess && (
                <div className="solutions-body shadow-custom-soft">
                    <div className="solution-headline">
                        <p>{t('iHaveAnIssueRelatedTo')}</p>
                    </div>
                    <div className="solutions-groups-wrapper">
                        <Link to={`${url}/personal`} className="solutions-groups-link">
                            <div className="solutions-groups-link-title">{t('Myself')} </div>
                            {/* <MyselfIcon key={1} className="solutions-icons" /> */}
                        </Link>
                        <Link to={`${url}/friends`} className="solutions-groups-link">
                            <span className="solutions-groups-link-title">{t('Friends')}</span>
                            {/* <FriendsIssuesIcon className="solutions-icons" /> */}
                        </Link>
                        <Link to={`${url}/family`} className="solutions-groups-link">
                            <span className="solutions-groups-link-title">{t('Family')}</span>
                            {/* <FamilyIssuesIcon className="solutions-icons" /> */}
                        </Link>
                        <Link to={`${url}/school`} className="solutions-groups-link">
                            <span className="solutions-groups-link-title">{t('School')}</span>
                            {/* <SchoolIssueIcon className="solutions-icons" /> */}
                        </Link>
                    </div>
                </div>
            )}
            {!solutionAccess && !loading && <div>{t('sorryYourSchoolRestrictedAccessToThisModule')}</div>}
        </div>
    )
}
